import styled from "styled-components";

/**
 * Texto do contador de caracteres mínimos. Função pura, para testar sem tela.
 *
 * `escritos` é o tamanho do texto como a validação do formulário o mede, para o
 * contador nunca dizer "ok" quando a validação ainda vai recusar.
 */
export function mensagemContadorMinimo({ escritos, minimo, campo }) {
  const falta = minimo - escritos;
  if (falta <= 0) return `${campo} tem o mínimo de ${minimo} caracteres.`;
  if (falta === 1) return `Falta 1 caractere para o mínimo de ${minimo}.`;
  return `Faltam ${falta} caracteres para o mínimo de ${minimo}.`;
}

const Texto = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.3;
  color: #6B6E70;

  .icone{ font-weight: 700; }

  &.ok{ color: var(--primary-color); }
  &.erro{ color: #C43333; }
`;

/**
 * Facilitador sob um campo de texto: quantos caracteres faltam para o mínimo e,
 * ao atingi-lo, a confirmação. O estado não depende só da cor: o ícone e o texto
 * mudam juntos. `destaque` pinta de vermelho quando o formulário já acusou erro
 * neste campo (o contador substitui a mensagem de erro de tamanho, que dizia a
 * mesma coisa).
 */
export default function ContadorMinimo({ valor = "", minimo, campo, destaque = false }) {
  const escritos = String(valor ?? "").length;
  const atingido = escritos >= minimo;
  const classe = atingido ? "ok" : destaque ? "erro" : "";

  return (
    <Texto className={classe}>
      <span className="icone" aria-hidden="true">{atingido ? "✓" : "•"}</span>
      <span>{mensagemContadorMinimo({ escritos, minimo, campo })}</span>
    </Texto>
  );
}
